import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import {
    Avatar,
    Alert,
    Box,
    Card,
    CardContent,
    Container,
    Divider,
    Grid,
    Skeleton,
    Stack,
    Typography,
} from "@mui/material";
import {
    red,
    orange,
    green,
    indigo,
    pink,
    lightBlue,
    yellow,
} from "@mui/material/colors";
import ViewComfySharpIcon from "@mui/icons-material/ViewComfySharp";
import ViewModuleSharpIcon from "@mui/icons-material/ViewModuleSharp";
import ViewQuiltSharpIcon from "@mui/icons-material/ViewQuiltSharp";
import ViewHeadlineSharpIcon from "@mui/icons-material/ViewHeadlineSharp";
import ViewCarouselSharpIcon from "@mui/icons-material/ViewCarouselSharp";
import ViewStreamIcon from "@mui/icons-material/ViewStream";
import ViewColumnSharpIcon from "@mui/icons-material/ViewColumnSharp";
import BusinessIcon from "@mui/icons-material/Business";
import Error403 from "../Error/403";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={1}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export default function Organization() {
    const [adminuserlist, setadminuserlist] = useState([]);
    const [opsuserlist, setopsuserlist] = useState([]);
    const [readonlyuserlist, setreadonlyuserlist] = useState([]);
    const [traineruserlist, setTraineruserlist] = useState([]);
    const [traineeuserlist, setTraineeuserlist] = useState([]);
    const [useroverview, setuseroverview] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fetch overview data
    useEffect(() => {
        const fetchOverview = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/api/user_management/overviewcount/`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                    }
                );
                if (!response.ok) {
                    throw new Error("Failed to fetch overview data");
                }
                const data = await response.json();
                if (data.detail) {
                    // Handle permission error
                } else {
                    setuseroverview(data);
                }
            } catch (err) {
                setError(err.message || "An error occurred while loading organization data");
            } finally {
                setLoading(false);
            }
        };

        fetchOverview();
    }, []);

    // Note: Other user list fetches are kept separate as they may be used elsewhere
    // They can be consolidated later if needed

    const [state, setState] = React.useState({
        email: "",
        username: "",
        groups: "",
        password: "",
        password2: "",
        errorMessage: "",
        right: false,
        radioList: "A",
        delete_id: "",
        active: "1",
    });
    const handleChange2 = (e) => {
        const { id, value } = e.target;
        setState((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const handleSubmitClick = (e) => {
        e.preventDefault();
        if (state.password !== state.password2) {
            setState({ errorMessage: "The passwords doesn't match" });
        } else {
            const register = {
                email: state.email,
                username: state.username,
                password: state.password,
                groups: [state.groups],
                is_active: state.active,
            };
            fetch(`${process.env.REACT_APP_API_URL}/api/user_management/user_list/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
                body: JSON.stringify(register),
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.email && data.username) {
                        handleClose();
                        setValue(2);
                    } else {
                        if (data.username) {
                            setState({ email: "" });
                            setState({ username: "" });
                            setState({ password: "" });
                            setState({ password2: "" });
                            setState({ groups: [] });
                            setState({ errorMessage: data.username[0] });
                        } else if (data.email) {
                            if (
                                data.email[0] === "User already exist, It is in Inactive state"
                            ) {
                                handleClickOpenActive();
                            } else if (
                                data.email[0] ===
                                "User already exist, but user not in our organization"
                            ) {
                                handleClickOpenActive();
                            } else {
                                setState({ email: "" });
                                setState({ username: "" });
                                setState({ password: "" });
                                setState({ password2: "" });
                                setState({ groups: [] });
                                setState({ errorMessage: data.email[0] });
                            }
                        } else if (data.password) {
                            setState({ email: "" });
                            setState({ username: "" });
                            setState({ password: "" });
                            setState({ password2: "" });
                            setState({ groups: [] });
                            setState({ errorMessage: data.password[0] });
                        } else {
                            setState({ email: "" });
                            setState({ username: "" });
                            setState({ password: "" });
                            setState({ password2: "" });
                            setState({ groups: [] });
                            setState({ errorMessage: data.errors.email[0] });
                        }
                    }
                })
                .catch((error) => {
                    setState({ errorMessage: "Something Went Wrong" });
                });
        }
    };

    const [userlist, setusers] = useState([]);
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/user_management/user_list/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.detail) {
                    localStorage.setItem("user_access", data.detail);
                } else {
                    setusers(data);
                }
            })
            .catch((error) => {
                // Handle error silently or show user-friendly message
            });
    }, []);

    const Delete = (UserId) => {
        return function () {
            fetch(
                `${process.env.REACT_APP_API_URL}/api/user_management/user_list/${UserId}/`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                    body: JSON.stringify({ is_active: "0" }),
                }
            )
                .then((response) => response.json())
                .then((data) => {
                    handleCloseDeleteindual();
                    // Refresh data instead of reloading page
                    // You can add a refresh function here if needed
                })
                .catch((error) => {
                    handleCloseDeleteindual();
                });
            handleCloseDeleteindual();
        };
    };
    const activate = (userId) => {
        return function () {
            const activate = {
                username: state.username,
                password: state.password,
                groups: state.groups.toString(),
                active: state.active,
            };
            fetch(
                `${process.env.REACT_APP_API_URL}/api/user_management/user/${userId}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                    body: JSON.stringify(activate),
                }
            )
                .then((response) => response.json())
            .then((data) => { })
            .catch((error) => {
                // Handle error - refresh data instead of reloading page
            });
        };
    };
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);

    const [alignment, setAlignment] = React.useState("left");

    const handleChange1 = (value) => {
        setAlignment(value);
    };
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        // Refresh data instead of reloading page
        // You can add a refresh function here if needed
    };

    const [opendelete, setOpendelete] = React.useState(false);
    const handleCloseDelete = () => {
        setOpendelete(false);
    };

    const [openactive, setOpenactive] = React.useState(false);

    const handleClickOpenActive = () => {
        setOpenactive(true);
    };

    const handleCloseActive = () => {
        setOpenactive(false);
    };

    const [opencontact, setOpencontact] = React.useState(false);

    const handleCloseContact = () => {
        setOpencontact(false);
    };

    const [opendeleteindual, setOpendeleteindual] = React.useState(false);

    const handleClickOpenDeleteindual = () => {
        setOpendeleteindual(true);
    };

    const handleCloseDeleteindual = () => {
        setOpendeleteindual(false);
    };

    function del(deleteid) {
        setState({ delete_id: deleteid });
    }

    const [erroropen, setErroropen] = React.useState(false);

    const handleCloserror = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setErroropen(false);
    };

    return (
        <React.Fragment>
            <Helmet>
                <title>LabAsService - Organization</title>
            </Helmet>
            {localStorage.getItem("user_access") ===
                "You do not have permission to perform this action." &&
                localStorage.getItem("group") !== "admin" ? (
                <Error403 />
            ) : (
                <Container maxWidth={false} sx={{ py: 6, pb: 8, px: { xs: 2, sm: 3, md: 4, lg: 5, xl: 6 } }}>
                    <Card sx={{ mb: 4 }}>
                        {/* Hero Header */}
                        <Box
                            sx={{
                                background: 'linear-gradient(135deg, rgba(46,125,50,0.12), rgba(21,101,192,0.12))',
                                borderTopLeftRadius: 12,
                                borderTopRightRadius: 12,
                                p: { xs: 2.5, md: 3 },
                            }}
                        >
                            <Stack direction="row" spacing={2} alignItems="center">
                                <BusinessIcon color="primary" sx={{ fontSize: 32 }} />
                                <Box>
                                    <Typography variant="h4" component="h1">
                                        Organization
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        View organization statistics and user overview
                                    </Typography>
                                </Box>
                            </Stack>
                        </Box>

                        <Divider />

                        {/* Error State */}
                        {error && (
                            <Box sx={{ p: { xs: 2.5, md: 3 }, pb: 0 }}>
                                <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
                                    {error}
                                </Alert>
                            </Box>
                        )}

                        <TabPanel value={value} index={0}>
                            <Box sx={{ p: { xs: 2.5, md: 3 } }}>
                                {loading ? (
                                    <Grid container spacing={3}>
                                        {[...Array(7)].map((_, index) => (
                                            <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={index}>
                                                <Card sx={{ height: "100%" }}>
                                                    <CardContent>
                                                        <Skeleton variant="rectangular" height={120} />
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        ))}
                                    </Grid>
                                ) : (
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                                            <Card 
                                                sx={{ 
                                                    height: "100%",
                                                    transition: 'all 0.3s ease-in-out',
                                                    '&:hover': {
                                                        boxShadow: 4,
                                                        transform: 'translateY(-4px)',
                                                    },
                                                }}
                                            >
                                                <CardContent>
                                                    <Grid
                                                        container
                                                        spacing={3}
                                                        sx={{ justifyContent: "space-between" }}
                                                    >
                                                        <Grid item>
                                                            <Typography
                                                                color="textSecondary"
                                                                gutterBottom
                                                                variant="h6"
                                                            >
                                                                No of Groups
                                                            </Typography>
                                                            <Typography color="textPrimary" variant="h3">
                                                                {useroverview?.group || 0}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Avatar
                                                                sx={{
                                                                    backgroundColor: pink[600],
                                                                    height: 56,
                                                                    width: 56,
                                                                }}
                                                            >
                                                                <ViewCarouselSharpIcon />
                                                            </Avatar>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                                            <Card 
                                                sx={{ 
                                                    height: "100%",
                                                    transition: 'all 0.3s ease-in-out',
                                                    '&:hover': {
                                                        boxShadow: 4,
                                                        transform: 'translateY(-4px)',
                                                    },
                                                }}
                                            >
                                                <CardContent>
                                                    <Grid
                                                        container
                                                        spacing={3}
                                                        sx={{ justifyContent: "space-between" }}
                                                    >
                                                        <Grid item>
                                                            <Typography
                                                                color="textSecondary"
                                                                gutterBottom
                                                                variant="h6"
                                                            >
                                                                Overall Users
                                                            </Typography>
                                                            <Typography color="textPrimary" variant="h3">
                                                                {useroverview?.all || 0}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Avatar
                                                                sx={{
                                                                    backgroundColor: red[600],
                                                                    height: 56,
                                                                    width: 56,
                                                                }}
                                                            >
                                                                <ViewComfySharpIcon />
                                                            </Avatar>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                                            <Card 
                                                sx={{ 
                                                    height: "100%",
                                                    transition: 'all 0.3s ease-in-out',
                                                    '&:hover': {
                                                        boxShadow: 4,
                                                        transform: 'translateY(-4px)',
                                                    },
                                                }}
                                            >
                                                <CardContent>
                                                    <Grid
                                                        container
                                                        spacing={3}
                                                        sx={{ justifyContent: "space-between" }}
                                                    >
                                                        <Grid item>
                                                            <Typography
                                                                color="textSecondary"
                                                                gutterBottom
                                                                variant="h6"
                                                            >
                                                                Admin Users
                                                            </Typography>
                                                            <Typography color="textPrimary" variant="h3">
                                                                {useroverview?.admin || 0}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Avatar
                                                                sx={{
                                                                    backgroundColor: orange[600],
                                                                    height: 56,
                                                                    width: 56,
                                                                }}
                                                            >
                                                                <ViewModuleSharpIcon />
                                                            </Avatar>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                                            <Card 
                                                sx={{ 
                                                    height: "100%",
                                                    transition: 'all 0.3s ease-in-out',
                                                    '&:hover': {
                                                        boxShadow: 4,
                                                        transform: 'translateY(-4px)',
                                                    },
                                                }}
                                            >
                                                <CardContent>
                                                    <Grid
                                                        container
                                                        spacing={3}
                                                        sx={{ justifyContent: "space-between" }}
                                                    >
                                                        <Grid item>
                                                            <Typography
                                                                color="textSecondary"
                                                                gutterBottom
                                                                variant="h6"
                                                            >
                                                                Ops Users
                                                            </Typography>
                                                            <Typography color="textPrimary" variant="h3">
                                                                {useroverview?.ops || 0}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Avatar
                                                                sx={{
                                                                    backgroundColor: green[600],
                                                                    height: 56,
                                                                    width: 56,
                                                                }}
                                                            >
                                                                <ViewQuiltSharpIcon />
                                                            </Avatar>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                                            <Card 
                                                sx={{ 
                                                    height: "100%",
                                                    transition: 'all 0.3s ease-in-out',
                                                    '&:hover': {
                                                        boxShadow: 4,
                                                        transform: 'translateY(-4px)',
                                                    },
                                                }}
                                            >
                                                <CardContent>
                                                    <Grid
                                                        container
                                                        spacing={3}
                                                        sx={{ justifyContent: "space-between" }}
                                                    >
                                                        <Grid item>
                                                            <Typography
                                                                color="textSecondary"
                                                                gutterBottom
                                                                variant="h6"
                                                            >
                                                                Read-Only Users
                                                            </Typography>
                                                            <Typography color="textPrimary" variant="h3">
                                                                {useroverview?.read || 0}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Avatar
                                                                sx={{
                                                                    backgroundColor: indigo[600],
                                                                    height: 56,
                                                                    width: 56,
                                                                }}
                                                            >
                                                                <ViewHeadlineSharpIcon />
                                                            </Avatar>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                                            <Card 
                                                sx={{ 
                                                    height: "100%",
                                                    transition: 'all 0.3s ease-in-out',
                                                    '&:hover': {
                                                        boxShadow: 4,
                                                        transform: 'translateY(-4px)',
                                                    },
                                                }}
                                            >
                                                <CardContent>
                                                    <Grid
                                                        container
                                                        spacing={3}
                                                        sx={{ justifyContent: "space-between" }}
                                                    >
                                                        <Grid item>
                                                            <Typography
                                                                color="textSecondary"
                                                                gutterBottom
                                                                variant="h6"
                                                            >
                                                                Trainers
                                                            </Typography>
                                                            <Typography color="textPrimary" variant="h3">
                                                                {useroverview?.trainer || 0}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Avatar
                                                                sx={{
                                                                    backgroundColor: lightBlue[600],
                                                                    height: 56,
                                                                    width: 56,
                                                                }}
                                                            >
                                                                <ViewStreamIcon />
                                                            </Avatar>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                                            <Card 
                                                sx={{ 
                                                    height: "100%",
                                                    transition: 'all 0.3s ease-in-out',
                                                    '&:hover': {
                                                        boxShadow: 4,
                                                        transform: 'translateY(-4px)',
                                                    },
                                                }}
                                            >
                                                <CardContent>
                                                    <Grid
                                                        container
                                                        spacing={3}
                                                        sx={{ justifyContent: "space-between" }}
                                                    >
                                                        <Grid item>
                                                            <Typography
                                                                color="textSecondary"
                                                                gutterBottom
                                                                variant="h6"
                                                            >
                                                                Trainees
                                                            </Typography>
                                                            <Typography color="textPrimary" variant="h3">
                                                                {useroverview?.trainee || 0}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <Avatar
                                                                sx={{
                                                                    backgroundColor: yellow[600],
                                                                    height: 56,
                                                                    width: 56,
                                                                }}
                                                            >
                                                                <ViewColumnSharpIcon />
                                                            </Avatar>
                                                        </Grid>
                                                    </Grid>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                )}
                            </Box>
                        </TabPanel>
                    </Card>
                </Container>
            )}
        </React.Fragment>
    );
}
